<template>
  <div>
    <iModal
      title="编辑合作伙伴"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="close()"
      :styles="{top: '50px'}"
    >
      <div class="my-modal">
        <div class="my-modal-content">
          <Form ref="formInline" :label-width="100" :model="formInline" :rules="ruleInline">
            <FormItem label="公司简称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="公司简称：" prop="shortName">
              <Input v-model="formInline.shortName" />
            </FormItem>
            <FormItem label="合作项目：" prop="itemName">
              <Input v-model="formInline.itemName" />
            </FormItem>
            <FormItem label="公司logo：">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
                style="width: 80px;height: 80px;line-height:80px"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" />
                  <div class="my-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr(item)"
                    ></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                    <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                type="drag"
                :action="uploadUrl"
                multiple
                style="display: inline-block;width:80px;"
                v-show="uploadList && uploadList.length < 1"
              >
                <div style="width: 80px;height:80px;padding-top: 7px;">
                  <div>
                    +
                    <p>上传</p>
                  </div>
                </div>
                <!-- 蒙版 -->
                <div
                  style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
                  @click.stop="selectType"
                ></div>
              </Upload>
              <p class="upload-p">（图片要求：2M以下的jpg或png，建议尺寸200*200px,比例1:1）</p>
            </FormItem>
            <FormItem label="公司描述：">
              <RadioGroup v-model="formInline.activityType">
                <Radio size="large" label="0">文字说明</Radio>
                <Radio size="large" label="1">图片展示</Radio>
              </RadioGroup>
              <div style="margin-top: 20px;">
                <div v-if="formInline.activityType == 0">
                  <FormItem prop="Introduction">
                    <Input type="textarea" v-model="formInline.Introduction" :rows="8" />
                  </FormItem>
                </div>
                <div v-if="formInline.activityType == 1">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload' + index"
                    style="width: 80px;height: 80px;line-height:80px"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr2(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                        <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:80px;"
                    v-show="uploadList2 && uploadList2.length < limitNum"
                  >
                    <div style="width: 80px;height:80px;padding-top: 7px;">
                      <div>
                        +
                        <p>上传</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                  <p style="font-size: 12px;">(图片要求：2M以下jpg或png的图片，宽度为：750px)</p>
                  <iModal title="View Image" v-model="visible">
                    <img
                      :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'"
                      v-if="visible"
                      style="width: 100%"
                    />
                  </iModal>
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确认</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <uploadChoose
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      fileType="img"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <uploadChoose
      @upload:local="uploadLocal2"
      @upload:material="uploadMaterial2"
      fileType="img"
      :maxCount="10"
      v-model="uploadChooseShowed2"
    />
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
import uploadChoose from "@components/uploadChoose/uploadChoose";
export default {
  name: "edit-partner",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      imgName: "",
      loading: false,
      showModal: false,
      formInline: {
        name: "",
        shortName: "",
        itemName: "",
        activityType: "0",
        Introduction: ""
      },
      ruleInline: {
        // 效验规则
        name: [{ required: true, message: "必填选项", trigger: "blur" }],
        shortName: [{ required: true, message: "必填选项", trigger: "blur" }],
        itemName: [{ required: true, message: "必填选项", trigger: "blur" }],
        Introduction: [
          { required: true, message: "必填选项", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司描述文字说明不能大于2000字",
            trigger: "blur"
          }
        ]
      },
      uploadList: [],
      defaultList: [],
      uploadList2: [],
      defaultList2: [],
      visible: false,
      limitNum: 10, // 图文显示的限制图片个数
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false, // 控制文件上传方式的显示和隐藏
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    info(val, oldVal) {
      if (val) {
        this.setData();
      }
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  created() {
    if (this.info) {
      this.setData();
    }
  },
  methods: {
    ...mapActions({
      editCooperation: "companyModule/editCooperation"
    }),
    setData() {
      let Introduction = "";
      if (this.info.styleId == '1') {
        this.defaultList2 = this.transfromImgList2(JSON.parse(this.info.introduction));
        Introduction = "";
      } else {
        Introduction = this.info.introduction;
        this.defaultList2 = [];
      }
      this.formInline = {
        name: this.info.name,
        shortName: this.info.shortName,
        itemName: this.info.itemName,
        activityType: String(this.info.styleId),
        Introduction: Introduction
      };
      if (this.info.logo) {
        this.defaultList = [
          {
            name: this.info.name,
            url: this.info.logo,
            status: "finished",
            percentage: 100
          }
        ];
      }
      // if (this.info.styleId === 1) {
      //   this.defaultList2 = this.transfromImgList2(
      //     JSON.parse(this.info.introduction)
      //   );
      // }
      this.uploadList = this.defaultList;
      this.uploadList2 = this.defaultList2;
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${limitNum} image only`);
      }
      console.log("this.uploadList", this.uploadList);
      return check;
    },
    handleBeforeUpload2() {
      const check = this.uploadList2.length < this.limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${this.limitNum} image only`);
      }
      console.log("this.uploadList2", this.uploadList2);
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let imgList2 = this.transfromImgList(this.uploadList2);
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传公司logo图片`);
        return;
      }
      if (form.activityType === "1" && imgList2.length === 0) {
        this.$Message.error(`请上传公司描述图片`);
        return;
      }
      if (form.activityType === "1" && imgList2.length > 0) {
        form.Introduction = imgList2;
      }
      let formData = {
        Id: this.info.id,
        SetValues: {
          Name: form.name,
          ShortName: form.shortName,
          ItemName: form.itemName,
          Logo: this.uploadList[0].url,
          StyleId: String(form.activityType),
          Introduction:
            form.activityType === "1"
              ? JSON.stringify(form.Introduction)
              : form.Introduction
        }
      };
      this.loading = true;
      let bool = await this.editCooperation(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("编辑成功");
        this.$emit("finish");
        this.close();
        this.$refs.upload.clearFiles();
      } else {
        this.$Message.error("编辑失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    transfromImgList2(arr) {
      let arr2 = [];
      if (arr && typeof arr !== "String") {
        arr.forEach(c => {
          arr2.push({ url: c, name: "", status: "finished", percentage: 100 });
        });
      }
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadChooseShowed2 = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if(this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return
        } else {
          this.uploadList.push({
          status: "finished",
          url: item
        });
        }
      }
    },
    uploadMaterial2(e) {
      for (let item of e) {
        if(this.uploadList2.length >= 10) {
          this.$Message.warning(`Upload 10 image only张图片`);
          return
        } else {
          this.uploadList2.push({
          status: "finished",
          url: item
        });
        }
      }
    },
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
    if (this.$refs.upload2) {
      this.uploadList2 = this.$refs.upload2.fileList;
    }
  },
  components: {
    uploadChoose
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
</style>